// extracted by mini-css-extract-plugin
export default {"day":"Q75uDaQ4","dayName":"raYe_qlX","dayNameScrolled":"_QHfVVcF","dayNameText":"AgEbS_1q","dayRows":"lbOlYarM","currentDay":"mSnlkKrp"};